module.exports = "/images/edit-icon.svg?271974038a558ea7663d0fe87367b604";